module.exports = __webpack_public_path__ + "static/media/market-global-map.71245a08.png";